import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const OWNER_EMAIL = 'ana@nutrianapereira.pt';

/**
 * Defense-in-depth: "Finanças Pessoais" é exclusiva da Ana. O servidor já bloqueia
 * (require_personal_finance_owner lê o email do token), este hook só evita que outro
 * utilizador veja o ecrã vazio a dar erros 403 e o redireciona de imediato.
 */
export function usePersonalFinanceGuard() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (loading) return;
    if (!user) return;
    if ((user.email || '').trim().toLowerCase() !== OWNER_EMAIL) {
      navigate('/admin/dashboard', { replace: true });
    }
  }, [user, loading, navigate]);
}

export default usePersonalFinanceGuard;
